/**
 * 系统状态管理
 * 用户信息及政区信息 放在根路径下，全系统使用
 * 其他模块的状态，使用 modules 并加命名空间
 */

import Vue from 'vue'
import Vuex from 'vuex'
import warnmonitor from './warnmonitor'
import workbench from './workbench'
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isOpenVoice: true
    },
    mutations: {
        updateVoiceSetting(state, payload) {
            state.isOpenVoice = payload;
        }
    },
    modules: {
        warnmonitor: {
            namespaced: true,
            ...warnmonitor
        },
        workbench: {
            namespaced: true,
            ...workbench
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js